export default {
    widgets: [],
    rects: [],
    activePreview: {}
};